import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';

import SectionTitle from '../SectionTitle';
import SectionDescription from '../SectionDescription';

import KeywordList from './KeywordList';
import styles from './styles.scss';

const KeywordsSection = ({ data, description }) => [
  <Row key="header">
    <Col className="mb-1">
      <SectionTitle title="Keyword List" />
      <SectionDescription description={description} />
    </Col>
  </Row>,
  <Row key="content">
    <Col className={`py-3 px-0 mx-3 ${styles.infoSection}`}>
      <KeywordList keywords={data} />
    </Col>
  </Row>,
];

KeywordsSection.propTypes = {
  data: PropTypes.array,
  description: PropTypes.string,
};

export default KeywordsSection;



// WEBPACK FOOTER //
// src/components/shared/KeywordsSection/index.jsx